<ion-header *ngIf="showHeader">
  <ion-toolbar>
    <ion-title>Edit POI</ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="closeModal()">Close</ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content class="ion-padding">
  <curbnturf-add-activity-form (close)="closeModal()" [activity]="activity" [admin]="admin">
  </curbnturf-add-activity-form>
</ion-content>
